import { StyledAddCard } from "@lib/components/MiniComponents/Others/AddCard/index.styled";
import { Typography } from "antd";
import { FaPlus } from "react-icons/fa";

type Props = {
  onClick?: () => void;
  title?: string;
};

export default function AddCard(props: Props) {
  const { onClick, title } = props;

  return (
    <StyledAddCard>
      <div onClick={onClick}>
        <FaPlus />
      </div>
      <Typography.Text>{title}</Typography.Text>
    </StyledAddCard>
  );
}
